<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Perfil de {{ realName }}</h1>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex md10 offset-md1>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Editar Perfil</h3>
                  </div>
                </v-card-title>
                <v-flex xs12>
                  <form>
                    <div v-if="errorsProfile.length" class="fondo">
                      <span class="spanError">Comprueba los siguientes errores:</span>
                      <ul>
                        <li
                          v-for="error in errorsProfile"
                          v-bind:key="error.id"
                          class="blanco">
                          {{ error }}
                        </li>
                      </ul>
                    </div>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="name"
                          v-model="name"
                          prepend-icon="account_circle"
                          label="Nombre de usuario (Necesario para acceder)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="fullName"
                          v-model="fullName"
                          prepend-icon="person"
                          label="Nombre completo"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-flex>
                <div>
                  <v-btn round color="teal blanco" @click="updateProfile">Actualizar perfil</v-btn>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="cuerpo">
          <v-layout row wrap>
            <v-flex md10 offset-md1>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Editar Contraseña</h3>
                  </div>
                </v-card-title>
                <v-flex xs12>
                  <form>
                    <div v-if="errorsPass.length" class="fondo">
                      <span class="spanError">Comprueba los siguientes errores:</span>
                      <ul>
                        <li
                          v-for="error in errorsPass"
                          v-bind:key="error.id"
                          class="blanco">
                          {{ error }}
                        </li>
                      </ul>
                    </div>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="password"
                          v-model="password"
                          prepend-icon="lock"
                          label="Nueva contraseña"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="repeatPassword"
                          v-model="repeatPassword"
                          prepend-icon="lock_outline"
                          label="Repite la contraseña"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          name="currentPassword"
                          v-model="currentPassword"
                          prepend-icon="lock_outline"
                          label="Contraseña actual"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-flex>
                <div>
                  <v-btn round color="teal blanco" @click="updatePassword">Actualizar contraseña</v-btn>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-snackbar
          :timeout= 6000
          :color="color"
          :multi-line="'multi-line'"
          v-model="snackbar">
          <v-icon dark>error_outline</v-icon>
          {{ error }}
          <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import store from '@/store/store'

  export default {
    data() {
      return {
        name: '',
        fullName: '',
        password: '',
        repeatPassword: '',
        currentPassword: '',
        errorsProfile: [],
        errorsPass: [],
        realName: store.state.user.fullName,
        error: null,
        snackbar: false,
        color: '',
      }
    },
    created() {
      this.getUser()
    },
    methods: {
      cargarSnack(msg, color){
        this.error = msg;
        this.snackbar = true;
        this.color = color;
      },
      async getUser() {
        let items = {
          id: store.state.user.id
        };
        try {
          const response = await Shared.getUser(items);
          this.name = response.data.data.name;
          this.fullName = response.data.data.fullName;
        } catch (err) {
          this.cargarSnack(err.response.data.msg, 'error');
        }
      },
      async updateProfile(){
        try{
          this.errorsProfile = [];
          if(this.name !== '' && this.fullName !== ''){
            const response = await Shared.updateProfile({
              id: store.state.user.id,
              name: this.name,
              fullName: this.fullName
            });
            this.$store.dispatch('setToken', response.data.token);
            this.$store.dispatch('setUser', response.data.user);
            this.realName = store.state.user.fullName;
            this.cargarSnack(response.data.msg, 'success');
            this.getUser();
          }else{
            this.errorsProfile.push('No puede haber campos vacíos');
          }
        }catch(err){
          this.cargarSnack(err.response.data.msg, 'error');
        }
      },
      validarPass(){
        this.errorsPass = [];
        let flag = true;
        if(this.password == '' || this.repeatPassword == '' || this.currentPassword == ''){
          flag = false;
          this.errorsPass.push('Hay campos vacíos');
        }
        if(this.password != this.repeatPassword){
          flag = false;
          this.errorsPass.push('Las contraseñas no coinciden');
        }
        return flag
      },
      async updatePassword(){
        try{
          if(this.validarPass()){
            const response = await Shared.updatePassword({
              id: store.state.user.id,
              password: this.password,
              currentPassword: this.currentPassword
            });
            this.cargarSnack(response.data.msg, 'success');
            this.getUser();
            this.password = '';
            this.currentPassword = '';
            this.repeatPassword = '';
          }
        }catch(err){
          this.cargarSnack(err.response.data.msg, 'error');
        }
      }
    }
  }
</script>

<style scoped>
  .cuerpo {
    margin-top: 30px;
    width: 100%;
  }
  .fondo{
    background-color: #ff5252;
    border-radius: 15px;
    width: 50%;
    position:relative;
    left: 25%;
    margin-bottom: 10px;
  }
  .blanco{
    color: white;
  }
  .spanError{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue